import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
import Typography from "@mui/material/Typography";

import { useTranslation } from "react-i18next";
import illustration from "../../assets/not-found.svg";

const Forbidden = () => {
	const { t } = useTranslation();

	return (
		<>
			<CssBaseline />
			<Container
				sx={{
					backgroundColor: "#084170",
					height: "100vh",
					display: "flex",
					flexDirection: "column",
					justifyContent: "center",
					alignItems: "center",
				}}
				maxWidth={false}
			>
				<img src={illustration} alt="Forbidden" style={{ maxWidth: "800px" }} />
				<Typography
					variant="h3"
					sx={{ color: "#fff", mt: "-40px", mb: "40px" }}
				>
					{t("forbidden_page_info")}
				</Typography>
			</Container>
		</>
	);
};

export default Forbidden;
